const DOUBLE = 'double'
const EQUATION = 'equation'
const RANGE = 'range'
const LOOKUPTABLE = 'lookuptable'
//const AMMONIA = "ammonialookuptable"

export const valueTypeList = [
  DOUBLE, EQUATION, RANGE,
]

export function valueTypeCheck(value, valueType) {
  switch (valueType) {
  case DOUBLE:
    return isNumberString(value)
  case RANGE:
    return true
  case EQUATION:
    return true
  case LOOKUPTABLE:
    return true
  default:
    throw 'Unsupported value type'
  }
}

function isNumberString(value) {
  // "",false,null Number(value) return 0
  if (value == '' || value == false || value == null) {
    return false
  }
  return !isNaN(Number(value))
}